(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    // Image gallery functionality
    const thumbnails = document.querySelectorAll('.product__thumbnail');
    const mainImage = document.querySelector('.product__main-image img');

    if (thumbnails.length > 0 && mainImage) {
      thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          const newImageUrl = thumbnail.dataset.imageUrl;
          if (newImageUrl) {
            mainImage.src = newImageUrl;
            thumbnails.forEach(t => t.classList.remove('product__thumbnail--active'));
            thumbnail.classList.add('product__thumbnail--active');
          }
        });
      });
    }

    // Form functionality
    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    const quantityInput = form.querySelector('[data-quantity-input]');
    const minusBtn = form.querySelector('[data-quantity-minus]');
    const plusBtn = form.querySelector('[data-quantity-plus]');
    const variantInputs = form.querySelectorAll('[data-variant-id]');
    const totalEl = form.querySelector('[data-product-total]');
    const totalPriceEl = form.querySelector('[data-total-price]');
    const priceEl = document.querySelector('[data-product-price]');

    function updateTotal() {
      const quantity = parseInt(quantityInput.value) || 1;
      const selectedVariant = form.querySelector('[data-variant-id]:checked');

      if (selectedVariant && totalEl && totalPriceEl) {
        const price = parseInt(selectedVariant.dataset.variantPrice);
        const total = price * quantity;
        totalPriceEl.textContent = formatMoney(total);
        totalEl.style.display = quantity > 1 ? 'flex' : 'none';
      }
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(cents / 100);
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        const val = parseInt(quantityInput.value) || 1;
        if (val > 1) {
          quantityInput.value = val - 1;
          updateTotal();
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        const val = parseInt(quantityInput.value) || 1;
        quantityInput.value = val + 1;
        updateTotal();
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', updateTotal);
    }

    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        // Update selected state
        form.querySelectorAll('.product__box-option').forEach(opt => {
          opt.classList.remove('product__box-option--selected');
        });
        input.closest('.product__box-option').classList.add('product__box-option--selected');

        // Update price display
        if (priceEl) {
          priceEl.textContent = formatMoney(parseInt(input.dataset.variantPrice));
        }

        updateTotal();
      });
    });

    updateTotal();
  })();

  } catch(e) { console.error(e); }
})();
})();
